import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ButtonColorTestPage() {
  return <div className="w-full min-h-screen bg-white py-12 px-6" data-id="element-517">
      <div className="max-w-4xl mx-auto" data-id="element-518">
        {/* Back button */}
        <div className="mb-8" data-id="element-519">
          <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-520">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-521" />
            <span data-id="element-522">Go Back</span>
          </Link>
        </div>
        {/* Main content */}
        <div className="bg-gray-50 rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-523">
          <h1 className="text-3xl font-bold text-gray-900 mb-10 text-center" data-id="element-524">
            CTA Button Color Options
          </h1>
          <div className="space-y-12" data-id="element-525">
            {/* Sunset Coral */}
            <div className="space-y-6" data-id="element-526">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-527">
                Sunset Coral (#f46b5b)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-528">
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-529">
                  <span data-id="element-530">Primary Button</span>
                </button>
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-531">
                  <span data-id="element-532">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-533" />
                </button>
                <button className="border-2 border-[#f46b5b] text-[#f46b5b] px-6 py-3 rounded-md font-medium hover:bg-[#f46b5b] hover:text-white transition-colors" data-id="element-534">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Golden Amber */}
            <div className="space-y-6" data-id="element-535">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-536">
                Golden Amber (#f6b736)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-537">
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-538">
                  <span data-id="element-539">Primary Button</span>
                </button>
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-540">
                  <span data-id="element-541">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-542" />
                </button>
                <button className="border-2 border-[#f6b736] text-[#f6b736] px-6 py-3 rounded-md font-medium hover:bg-[#f6b736] hover:text-white transition-colors" data-id="element-543">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Bright Sky Blue */}
            <div className="space-y-6" data-id="element-544">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-545">
                Bright Sky Blue (#4dc4f7)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-546">
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-547">
                  <span data-id="element-548">Primary Button</span>
                </button>
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-549">
                  <span data-id="element-550">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-551" />
                </button>
                <button className="border-2 border-[#4dc4f7] text-[#4dc4f7] px-6 py-3 rounded-md font-medium hover:bg-[#4dc4f7] hover:text-white transition-colors" data-id="element-552">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Comparison Section */}
            <div className="pt-10 border-t border-gray-200" data-id="element-553">
              <h2 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-554">
                Side-by-Side Comparison
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-555">
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-556">
                  <span data-id="element-557">Sunset Coral</span>
                  <ArrowRightIcon size={18} data-id="element-558" />
                </button>
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-559">
                  <span data-id="element-560">Golden Amber</span>
                  <ArrowRightIcon size={18} data-id="element-561" />
                </button>
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-562">
                  <span data-id="element-563">Bright Sky Blue</span>
                  <ArrowRightIcon size={18} data-id="element-564" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}